/**
 * Loyalty small box auto-update on cart changes
 */

const loyaltySmallBoxContainer = document.querySelector('.js-loyalty-container')

if (loyaltySmallBoxContainer) {
    const updateLoyaltySmallBox = () => {
        fetch('/get-loyalty-small-box', {
            method: 'GET',
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
            .then(response => response.text())
            .then(html => {
                loyaltySmallBoxContainer.innerHTML = html
            })
            .catch(error => {
                console.error('Error updating loyalty small box:', error)
            })
    }

    // Listen to cart events
    rEvent.on('Custom.Cart.addedItem', function (data) {
        if (data.response && data.response.status) {
            updateLoyaltySmallBox()
        }
    })

    rEvent.on('Custom.Cart.updatedItem', function (data) {
        if (data.response && data.response.status) {
            updateLoyaltySmallBox()
        }
    })

    rEvent.on('Custom.Cart.removedItem', function (data) {
        if (data.response && data.response.status) {
            updateLoyaltySmallBox()
        }
    })
}
